import eventsMapper from './events-mapper'

const ALLOWED_MESSAGE_TYPES = ['public', 'automatic']

const HIDE_AGENT_MESSAGE_STATUS = ['error', 'waiting']

const CLOSED_CONVERSATION_STATUSES = [2, 5]

export const attachments = ({ message }) => message.attachments

export const typing = ({ typing }) => typing

export const chat = ({ chat }) => chat

export const unrededMessages = ({ chat }) =>
  chat && !CLOSED_CONVERSATION_STATUSES.includes(chat.status)
    ? chat.messages.filter(
        m =>
          !m.clientRead &&
          ALLOWED_MESSAGE_TYPES.includes(m.type) &&
          !HIDE_AGENT_MESSAGE_STATUS.includes(m.status)
      ).length
    : 0

export const chatStatus = ({ chat }) => (chat ? chat.status : -1)

export const chatKey = ({ chat }) => (chat ? chat.key : '')

export const scrollBottom = ({ scrollBottom }) => scrollBottom

export const onConversation = ({ chat }) => chat

export const ticket = ({ ticket }) => ticket

export const agent = ({ chat }) => (chat ? chat.agent : undefined)

export const conversationClosed = ({ chat }) =>
  chat && ((chat.leave && chat.leave.time) || (chat.closed && chat.closed.time))

export const reading = ({ reading }) => reading

export const conversationMessages = ({ chat, messages }) => {
  if (chat) {
    let events = chat.messages.filter(m =>
      ALLOWED_MESSAGE_TYPES.includes(m.type)
    )

    events = events.concat(
      messages.filter(m => !chat.messages.some(cm => cm.key === m.key))
    )
    return events
  } else {
    return messages
  }
}

export const events = ({ chat, messages }) => eventsMapper(chat, messages)

export const closingChatLoader = ({ chatClosingLoading }) => chatClosingLoading

export const surveyAnswered = ({ surveyAnswered }) => surveyAnswered

export const chatSurvey = ({ chat }) => (chat && chat.survey) || undefined

export const creatingChat = ({ creatingChat }) => creatingChat

export const focusedMessageKey = ({ focusedMessageKey }) => focusedMessageKey

export const commentError = ({ commentError }) => commentError

export const emojiPageStatus = ({ emojiPageStatus }) => emojiPageStatus

export const comment = ({ comment }) => comment

export const unsendedQuoteMessage = ({ unsendedQuoteMessage }) =>
  unsendedQuoteMessage

export const showKbCard = ({ showKbCard }) => showKbCard

export const isVoiceRecording = ({ voiceRecording }) => voiceRecording

export const dragging = ({ dragging }) => dragging

export const disableUserInput = (
  _,
  { conversationMessages, inBotFlux, agent, chat }
) => {
  const lastMessage =
    conversationMessages &&
    conversationMessages[conversationMessages.length - 1]

  const isBlockByConfig =
    lastMessage &&
    lastMessage.extendedData &&
    lastMessage.extendedData.bot &&
    !lastMessage.extendedData.bot.allowUserInput

  const blockedByLastMessageType =
    lastMessage && lastMessage.user && lastMessage.user.type !== 4

  if (inBotFlux && chat && chat.messages && !chat.messages.length) return true

  return !agent && inBotFlux && (isBlockByConfig || blockedByLastMessageType)
}

export const showNumberInput = ({ showNumberInput }) => showNumberInput

export const showDatePicker = ({ showDatePicker }) => showDatePicker

export const numberInputValid = ({ numberInputValid }) => numberInputValid

export const inBotConversation = (_, { inBotFlux, agent }) => {
  return !agent && inBotFlux
}

export const datePickerValid = ({ datePickerValid }) => datePickerValid

export const getUploadInProcess = ({ hasUploadInProcess }) => hasUploadInProcess

export const botHasFinished = ({ chat }) =>
  chat && chat.botInfo && chat.botInfo.hasFinished

export const closed = ({ chat }) => chat && chat.closed

export const token = ({ token }) => token
